module.exports = "/static/assets/71ecbef8269ffd9a54997de47aa7d9ee.png";